/**
 * /frontend/src/features/analytics/components/shared/KPICardRow.js
 */

import React from 'react';
import KPICard from './KPICard';
import './KPICardRow.css';

/**
 * Renders a row of KPI cards.
 * @param {{items?:Array<{key:string,label:string,value:string,subLabel?:string,trend?:string,trendTone?:'good'|'bad'|'neutral',valueTone?:'default'|'green'}>,children?:React.ReactNode}} props
 * @returns {JSX.Element}
 */
const KPICardRow = ({ items, children }) => {
  if (children) {
    return <section className="analytics-kpi-row">{children}</section>;
  }

  return (
    <section className="analytics-kpi-row">
      {(items || []).slice(0, 4).map((item) => (
        <KPICard
          key={item.key}
          label={item.label}
          value={item.value}
          subLabel={item.subLabel}
          trend={item.trend}
          trendTone={item.trendTone}
          valueTone={item.valueTone}
        />
      ))}
    </section>
  );
};

export default KPICardRow;
